
(function ($) {

    async function loadRates() {

        const script = document.createElement('script');
        document.body.appendChild(script);
        script.async = true;
        script.defer = true;
        script.src = 'https://content.webapi-services.net/web_assets/scripts/live-rates/widget.var.min.js?env='+env;
        script.onload = () => {
            LiveRates.default({
                folder: 76,
                broker: 1,
                frequency: 6000,
                container: 'lr-widget-wrapper',
                activeTab: 2,
                maxLines: 8,
                //exclude : ['high','low'],
                cssLink: '',
                lang: 'ja',
                exclude_tab:[8,9],
                icons: true
            }).then(function () {
                import(/* webpackPreload: true */'./live-rates.css');
            })
        }; 
    
    }


    let env = window.getparam('env') || 'prod';

    loadRates()
        .then(() => { $('.lr-loader').hide() })
        .catch(err => {
            console.error(err);
        });

})(window.jQuery);


